import { Navigate, Route, Routes } from 'react-router-dom';

import { ChatPage } from '../pages';

export const ChatV2Routes = () => {
    return (
        <Routes>
            <Route index element={<ChatPage />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};
